const MoneyIcon = ({ ...props }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.16675 6.5H22.1667M2.16675 6.5V18.5M2.16675 6.5H6.16675C6.16675 8.70915 4.37589 10.5 2.16675 10.5V6.5ZM22.1667 6.5V18.5M22.1667 6.5H18.1667C18.1667 8.70915 19.9576 10.5 22.1667 10.5V6.5ZM22.1667 18.5H2.16675M22.1667 18.5V14.5C19.9576 14.5 18.1667 16.2908 18.1667 18.5H22.1667ZM2.16675 18.5H6.16675C6.16675 16.2908 4.37589 14.5 2.16675 14.5V18.5ZM12.1667 15.5C13.5474 15.5 14.6667 14.1568 14.6667 12.5C14.6667 10.8432 13.5474 9.5 12.1667 9.5C10.786 9.5 9.66675 10.8432 9.66675 12.5C9.66675 14.1568 10.786 15.5 12.1667 15.5Z"
        stroke="#FB3973"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MoneyIcon;
